// Example of creating a MUI dialog modal for adding a payment
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { CustomersAutoComplete } from "../../../../components/AutoComplete/Customers";
import { useAppSelector } from "../../../../utils/hooks";

export const UpdateTrayModal = ({
  customersData,
  open,
  columns,
  onClose,
  onSubmit,
}) => {
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [trayAReturn, setTrayAReturn] = useState();
  const [trayBReturn, setTrayBReturn] = useState();
  const [customersOption, setCustomersOption] = useState([]);
  const { customers } = useAppSelector(customersData);

  useEffect(() => {
    setCustomersOption([
      ...customers.map((data) => {
        data = {
          ...data,
          label: data.name_english + " " + data.name_urdu,
        };
        return data;
      }),
    ]);
  }, []);

  useEffect(() => {
    setSelectedCustomer("");
    setTrayAReturn("");
    setTrayBReturn(" ");
  }, [open]);

  const handleUpdateTray = (event) => {
    event.preventDefault();
    console.log(selectedCustomer);
    if (!selectedCustomer) {
      alert('Please select a customer')
    }
    onSubmit({ selectedCustomer, trayAReturn, trayBReturn });
    onClose();
  };

  return (
    <>
      <Dialog open={open}>
        <DialogTitle textAlign="center">Return Tray</DialogTitle>
        <DialogContent>
          <form>
            <Stack
              sx={{
                width: "100%",
                minWidth: { xs: "350px", sm: "500px", md: "400px" },
                gap: "1.5rem",
              }}
            >
              <Box>
                <label>Selected Customer</label>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={customersOption}
                  sx={{
                    minWidth: 200,
                    display: "flex",
                  }}
                  value={selectedCustomer}
                  onChange={(e, newValue) => setSelectedCustomer(newValue)}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Box>
              <Box>
                <label>Return Tray-A</label>
                <TextField
                  type="number"
                  sx={{ minWidth: "100%" }}
                  value={trayAReturn}
                  onChange={(e) => setTrayAReturn(e.target.value)}
                />
              </Box>
              <Box>
                <label>Return Tray-B</label>
                <TextField
                  type="number"
                  sx={{ minWidth: "100%" }}
                  value={trayBReturn}
                  onChange={(e) => setTrayBReturn(e.target.value)}
                />
              </Box>
            </Stack>
          </form>
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            color="secondary"
            onClick={handleUpdateTray}
            variant="contained"
            disabled={selectedCustomer === ""}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
